/*
  RBN: compact option steppers ("COLOR  < BLACK >", "SIZE  < S >"), markup in snippets/variant-main-picker,
  styles in snippets/rbn-option-stepper. Loaded once from layout/theme.liquid, so the arrows also work in
  content the theme inserts with JavaScript (Quick Add), where inline <script> tags never run.
  The steppers drive the theme's own (hidden) variant radio buttons, so the theme still handles the variant,
  price, gallery, Add to cart and URL. Only valid combinations are offered: when a color has no stock in the
  current size, the size moves to the first size that is in stock for that color.
  window.rbnStepper is shared with the Favorites page cards.
*/
(function () {
  if (window.rbnStepper) return;

  /* Shared logic: options are 1-based positions; variants are [{ id, o: [values], a: available }]. */
  function prefixOk(variants, sel, pos, value) {
    /* Is `value` for option `pos` in stock, given the options chosen before it? */
    return variants.some(function (v) {
      if (!v.a || v.o[pos - 1] !== value) return false;
      for (var i = 0; i < pos - 1; i++) if (v.o[i] !== sel[i]) return false;
      return true;
    });
  }
  function exact(variants, sel) {
    return variants.find(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); }) || null;
  }
  /* Returns the new selection after stepping option `pos` by `dir` (+1 / -1). */
  function step(variants, values, sel, pos, dir) {
    var list = values[pos - 1];
    var n = list.length;
    var cur = Math.max(0, list.indexOf(sel[pos - 1]));
    var anyOk = list.some(function (v) { return prefixOk(variants, sel, pos, v); });
    var next = sel.slice();
    for (var k = 1; k <= n; k++) {
      var cand = list[(cur + dir * k + n * k) % n];
      if (!anyOk || prefixOk(variants, sel, pos, cand)) { next[pos - 1] = cand; break; }
    }
    /* Later options: keep the current value when it is in stock, otherwise take the first one that is. */
    for (var p = pos + 1; p <= values.length; p++) {
      if (prefixOk(variants, next, p, next[p - 1])) continue;
      var ok = values[p - 1].find(function (v) { return prefixOk(variants, next, p, v); });
      if (ok) next[p - 1] = ok;
    }
    return next;
  }
  window.rbnStepper = { step: step, exact: exact, prefixOk: prefixOk };

  /* ---------- Product page: drive the theme's variant picker ---------- */
  function pickerState(picker) {
    var dataEl = picker.querySelector('script[data-rbn-variants]');
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    if (!variants.length) return null;
    var count = variants[0].o.length;
    var values = [], radios = [], sel = [];
    for (var p = 1; p <= count; p++) {
      var rs = Array.prototype.slice.call(picker.querySelectorAll('fieldset.rbn-step-source input[type="radio"][data-input-id^="' + p + '-"]'));
      radios[p - 1] = rs;
      if (rs.length) {
        values[p - 1] = rs.map(function (r) { return r.value; });
        var checked = rs.find(function (r) { return r.checked; }) || rs[0];
        sel[p - 1] = checked.value;
      } else {
        /* Option with a single value (not shown as buttons). */
        var single = [];
        variants.forEach(function (v) { if (single.indexOf(v.o[p - 1]) === -1) single.push(v.o[p - 1]); });
        values[p - 1] = single;
        sel[p - 1] = single[0];
      }
    }
    return { variants: variants, values: values, radios: radios, sel: sel };
  }
  function renderPicker(picker, st, sel) {
    picker.querySelectorAll('[data-rbn-step]').forEach(function (box) {
      var p = Number(box.dataset.optionPosition);
      var out = box.querySelector('[data-rbn-step-value]');
      if (out) out.textContent = sel[p - 1];
    });
    var status = picker.querySelector('[data-rbn-step-status]');
    var v = exact(st.variants, sel);
    if (status) status.textContent = !v ? 'This combination is not available.' : (v.a ? '' : 'Sold out in this color and size.');
  }
  function onStep(btn) {
    var box = btn.closest('[data-rbn-step]');
    var picker = box && box.closest('variant-picker');
    if (!picker) return;
    var st = pickerState(picker);
    if (!st) return;
    var pos = Number(box.dataset.optionPosition);
    var next = step(st.variants, st.values, st.sel, pos, Number(btn.dataset.rbnStepDir));
    var changed = [];
    next.forEach(function (val, i) {
      if (val === st.sel[i]) return;
      var r = (st.radios[i] || []).find(function (x) { return x.value === val; });
      if (r) { r.checked = true; changed.push({ pos: i + 1, radio: r }); }
    });
    if (!changed.length) return;
    renderPicker(picker, st, next);
    /* One change event; the theme reads every checked option and re-renders the variant. */
    var trigger = (changed.find(function (c) { return c.pos === pos; }) || changed[0]).radio;
    trigger.dispatchEvent(new Event('change', { bubbles: true }));
    /* Keep ?variant= in the address bar exact when two options changed at once (product page only: never in
       Quick Add or a product card, where the address bar belongs to the collection page). */
    var v = exact(st.variants, next);
    if (v && picker.dataset.templateProductMatch === 'true' && !picker.closest('quick-add-dialog, product-card')) {
      setTimeout(function () {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }, 120);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('variant-picker [data-rbn-step-dir]');
    if (btn) { e.preventDefault(); onStep(btn); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var box = e.target && e.target.closest && e.target.closest('variant-picker [data-rbn-step]');
    if (!box) return;
    e.preventDefault();
    var btn = box.querySelector('[data-rbn-step-dir="' + (e.key === 'ArrowLeft' ? '-1' : '1') + '"]');
    if (btn) onStep(btn);
  });
})();
